


import React from "react";

export default function ServiceCard({ item, openBooking }) {
  const { title, price, desc, img } = item;

  return (
    <div className="bg-white rounded-2xl border-2 border-red-600
      shadow-md hover:shadow-2xl hover:shadow-red-400/50 transition-all duration-300 
      hover:scale-[1.03] p-4">

      {/* Image */}
      <div className="h-40 overflow-hidden rounded-xl">
        <img
          src={img}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
        />
      </div>

      {/* Title */}
      <h3 className="text-lg font-bold text-gray-900 mt-3">{title}</h3>

      {/* Description */}
      <p className="text-gray-600 text-sm mt-1">{desc}</p>

      {/* Bottom Section */}
      <div className="mt-4 flex justify-between items-center">
        <span className="text-xl font-bold text-red-600">{price}</span>

        <button
          onClick={() => openBooking(title)}
          className="bg-red-600 text-white px-4 py-2 rounded-xl font-semibold 
            hover:bg-red-700 transition shadow-md"
        >
          Book Now
        </button>
      </div>
    </div>
  );
}
